import React from 'react';
import { Link } from 'react-router-dom';
import { useCanonical } from '../hooks/useCanonical';
import { usePageMeta } from '../hooks/usePageMeta';
import { BlogShell } from './BlogShell';
import { POSTS, SITE, formatDate } from './posts';

const TITLE = 'Blog | Hisab Kitab';
const DESCRIPTION =
  'Practical guides on budgeting, shared expenses and tracking your money in India, from the Hisab Kitab team.';

function BlogIndex() {
  useCanonical(`${SITE}/blog`);
  usePageMeta(TITLE, DESCRIPTION);
  return (
    <BlogShell>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-2">Blog</h1>
      <p className="text-zinc-500 mb-12">Money tips and product guides from the Hisab Kitab team.</p>
      <ul className="space-y-6">
        {POSTS.map((post) => (
          <li key={post.slug}>
            <Link
              to={`/blog/${post.slug}`}
              className="block rounded-xl border border-zinc-800 bg-zinc-900/40 p-6 hover:border-yellow-400/60 transition-colors"
            >
              <p className="text-xs text-zinc-500 mb-2">
                {formatDate(post.date)} · {post.readingMinutes} min read
              </p>
              <h2 className="text-xl font-bold text-white mb-2">{post.title}</h2>
              <p className="text-zinc-400 leading-relaxed">{post.description}</p>
            </Link>
          </li>
        ))}
      </ul>
    </BlogShell>
  );
}

export default BlogIndex;
